module.exports = __webpack_public_path__ + "img/star-4.8be69a01.svg";